import { render, staticRenderFns } from "./ReportUserLoginCountryDetailsScreen.vue?vue&type=template&id=134fa75e&scoped=true&"
import script from "./ReportUserLoginCountryDetailsScreen.vue?vue&type=script&lang=js&"
export * from "./ReportUserLoginCountryDetailsScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134fa75e",
  null
  
)

export default component.exports